/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
// BRAND-SPECIFIC-TODO
import React, { PureComponent, Fragment } from 'react';
import logger from '@tcp/core/src/utils/loggerInstance';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Button from '@tcp/core/src/components/common/atoms/Button';
import {
  getIconPath,
  routeToStoreDetails,
  getSiteId,
  isSNJ,
  getDateObject,
} from '@tcp/core/src/utils';
import { getLocator } from '@tcp/core/src/utils/utils';
import { getStoreHours } from '@tcp/core/src/utils/utils.extension';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import style, {
  TileHeader,
  TileFooter,
  TileBody,
  FavStore,
} from '../styles/StoreAddressTile.style';
import { listingHeader, listingType, detailsType, propTypes, defaultProps } from './prop-types';
import ShopThisStoreCta from '../../../atoms/ShopThisStoreCta/view/ShopThisStoreCta';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  StoreLocatorLabels,
  STORE_DETAILS_LABELS,
  STORE_LANDING_LABELS,
  STORE_LIST_LABELS,
} from '../../../../features/storeLocator/Labels/StoreLocator.labels';

const storeAddressText = (city, state, zipCode) =>
  city && state && zipCode ? `${city}, ${state}, ${zipCode}` : '';

const customStyle = {
  marginBottom: 0,
};

// Log once to raygun and do not log on each re-render
let isErrorLogged = false;

class StoreAddressTile extends PureComponent {
  constructor(props) {
    super(props);
    this.storeLabels = {
      ...getLabelFromCopyOrFromTranslation(STORE_DETAILS_LABELS, StoreLocatorLabels),
      ...getLabelFromCopyOrFromTranslation(STORE_LANDING_LABELS, StoreLocatorLabels),
      ...getLabelFromCopyOrFromTranslation(STORE_LIST_LABELS, StoreLocatorLabels),
    };

    this.storeLandingLabels = getLabelFromCopyOrFromTranslation(
      STORE_LANDING_LABELS,
      StoreLocatorLabels
    );

    this.storeDetailLabels = getLabelFromCopyOrFromTranslation(
      STORE_DETAILS_LABELS,
      StoreLocatorLabels
    );
  }

  getIsFavStoreIcon() {
    const { isStoreDetailsDesktopRedesignEnabled, isStoreDetailsRedesignMobileEnabled } =
      this.props;
    return (
      <FavStore
        isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
        isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
      >
        {isStoreDetailsDesktopRedesignEnabled || isStoreDetailsRedesignMobileEnabled ? (
          <Image
            src={getIconPath('blackFavIcon')}
            alt="blackFavIcon"
            className="favorite-store-icon"
          />
        ) : (
          <>
            <Image src={getIconPath('star-icon')} alt="" className="favorite-store-icon" />
            <BodyCopy component="span" fontSize="fs12" fontFamily="secondary">
              {renderLabel(
                this.storeLandingLabels.lbl_storelanding_favStore,
                'lbl_storelanding_favStore'
              )}
            </BodyCopy>
          </>
        )}
      </FavStore>
    );
  }

  renderMarkerIcon = (fromCurrentSelectedStore) => {
    const iconPath = getIconPath('markerIcon');
    return (
      fromCurrentSelectedStore && <Image src={iconPath} alt="marker-icon" className="marker-icon" />
    );
  };

  currentStoreCheck(isStsCtaEnabled, fromCurrentSelectedStore, flow) {
    switch (flow) {
      case 'currentStoreABOn':
        return isStsCtaEnabled && fromCurrentSelectedStore;
      case 'currentStoreABOff':
        return !isStsCtaEnabled && fromCurrentSelectedStore;
      default:
        return !fromCurrentSelectedStore;
    }
  }

  labelUpdate(fromCurrentSelectedStore) {
    return fromCurrentSelectedStore
      ? renderLabel(
          this.storeLandingLabels.lbl_storelanding_getdirections_link,
          'lbl_storelanding_getdirections_link'
        )
      : renderLabel(
          this.storeDetailLabels.lbl_storedetail_storedetailTxt,
          'lbl_storedetail_storedetailTxt'
        )?.toLowerCase();
  }

  getClassName(name) {
    return isSNJ() ? name : '';
  }

  getDetailsTileFooter(fromCurrentSelectedStore) {
    const {
      locatorGetDirections,
      openStoreDirections,
      variation,
      store: {
        basicInfo: { storeName },
      },
      isFavorite,
      showSetFavorite,
      tileButtonClass,
      isStoreDetailsDesktopRedesignEnabled,
      isShopThisStoreEnabled,
      isStsCtaEnabled,
      updateStore,
      store,
      isStoreDetailsRedesignMobileEnabled,
      fromStoreDetailPage,
    } = this.props;
    return isStoreDetailsDesktopRedesignEnabled || isStoreDetailsRedesignMobileEnabled ? (
      <Fragment>
        {isShopThisStoreEnabled
          ? this.currentStoreCheck(isStsCtaEnabled, fromCurrentSelectedStore, 'currentStoreABOn') &&
            this.renderStsCta(store.basicInfo, updateStore, store, () => {}, true, {
              fromCurrentSelectedStore,
              isStoreDetailsDesktopRedesignEnabled,
              isStoreDetailsRedesignMobileEnabled,
              fromStoreDetailPage,
            })
          : ''}
        <div>
          {this.renderMarkerIcon(fromCurrentSelectedStore)}
          <Button
            className="get-directions-link"
            type="button"
            aria-label={`${renderLabel(
              this.storeDetailLabels.lbl_storedetail_storedetailTxt,
              'lbl_storedetail_storedetailTxt'
            )} for ${storeName}`}
            data-locator={locatorGetDirections}
            onClick={openStoreDirections}
          >
            {this.labelUpdate(fromCurrentSelectedStore)}
          </Button>
        </div>
        {isShopThisStoreEnabled
          ? this.currentStoreCheck(
              isStsCtaEnabled,
              fromCurrentSelectedStore,
              'currentStoreABOff'
            ) &&
            this.renderStsCta(store.basicInfo, updateStore, store, () => {}, false, {
              fromCurrentSelectedStore,
              isStoreDetailsDesktopRedesignEnabled,
              isStoreDetailsRedesignMobileEnabled,
              fromStoreDetailPage,
            })
          : ''}
        {isShopThisStoreEnabled
          ? this.currentStoreCheck(isStsCtaEnabled, fromCurrentSelectedStore) &&
            this.renderStsCta(store.basicInfo, updateStore, store, () => {}, false, {
              fromCurrentSelectedStore,
              isStoreDetailsDesktopRedesignEnabled,
              isStoreDetailsRedesignMobileEnabled,
              fromStoreDetailPage,
            })
          : ''}
      </Fragment>
    ) : (
      <Fragment>
        <div className={`tile-footer__fullwidth ${tileButtonClass}`}>
          <Button
            className={this.getClassName('button-style')}
            buttonVariation="fixed-width"
            fill={isSNJ() ? '' : 'BLUE'}
            type="button"
            aria-label={`${renderLabel(
              this.storeLandingLabels.lbl_storelanding_getdirections_link,
              'lbl_storelanding_getdirections_link'
            )} for ${storeName}`}
            data-locator={locatorGetDirections}
            onClick={openStoreDirections}
          >
            {renderLabel(
              this.storeLandingLabels.lbl_storelanding_getdirections_link,
              'lbl_storelanding_getdirections_link'
            )}
          </Button>
        </div>
        <div className={`tile-footer__fullwidth ${tileButtonClass}`}>
          {variation === detailsType && !isFavorite && showSetFavorite && this.getFavLink()}
        </div>
      </Fragment>
    );
  }

  getListingTileFooter() {
    const {
      isFavorite,
      setFavoriteStore,
      locatorSetFavStore,
      store,
      openStoreDetails,
      userStoreId,
      isGenericUser,
      updateStore,
      isStsCtaEnabled,
      trackAnalyticsClick,
      isShopThisStoreEnabled,
      setDefaultSuggestedStoresAction,
      isBossMultiStoreEnabled,
    } = this.props;

    const { basicInfo } = store;
    const { storeName } = basicInfo;
    return (
      <Fragment>
        <div>
          {isShopThisStoreEnabled
            ? isStsCtaEnabled &&
              this.renderStsCta(basicInfo, updateStore, store, trackAnalyticsClick, true)
            : ''}
          <Anchor
            fontSizeVariation="medium"
            underline
            to={`/${getSiteId()}${routeToStoreDetails(store).url}`}
            handleLinkClick={(event) => openStoreDetails(event, store)}
            anchorVariation="primary"
            target="_blank"
            className="store-details-link"
            aria-label={`${storeName} ${renderLabel(
              this.storeLandingLabels.lbl_storelanding_storedetails_link,
              'lbl_storelanding_storedetails_link'
            )}`}
            noLink
          >
            {renderLabel(
              this.storeLandingLabels.lbl_storelanding_storedetails_link,
              'lbl_storelanding_storedetails_link'
            )}
          </Anchor>
          {isShopThisStoreEnabled
            ? !isStsCtaEnabled &&
              this.renderStsCta(basicInfo, updateStore, store, trackAnalyticsClick, false)
            : ''}
        </div>
        <div>
          {isFavorite && !isGenericUser && this.getIsFavStoreIcon()}
          {!isFavorite && !isGenericUser && (
            <ClickTracker clickData={{ customEvents: ['event67'], storeId: userStoreId }}>
              <Button
                onClick={() => {
                  setFavoriteStore(store);
                  if (isBossMultiStoreEnabled) {
                    setDefaultSuggestedStoresAction([store]);
                  }
                }}
                buttonVariation="fixed-width"
                type="button"
                data-locator={locatorSetFavStore}
                aria-label={`${storeName} ${renderLabel(
                  this.storeLandingLabels.lbl_storelanding_setfavStore,
                  'lbl_storelanding_setfavStore'
                )}`}
              >
                {renderLabel(
                  this.storeLandingLabels.lbl_storelanding_setfavStore,
                  'lbl_storelanding_setfavStore'
                )}
              </Button>
            </ClickTracker>
          )}
        </div>
      </Fragment>
    );
  }

  renderFavIcon(isStoreDetailsRedesignMobileEnabled, variation, isFavorite, showSetFavorite) {
    return (
      isStoreDetailsRedesignMobileEnabled && (
        <div className="address-meta__right">
          {variation === detailsType && isFavorite && this.getIsFavStoreIcon()}
          {variation === detailsType && !isFavorite && showSetFavorite && this.getFavLink()}
        </div>
      )
    );
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getDetailsTileHeader() {
    const {
      store: {
        basicInfo: { storeName },
      },
      titleClickCb,
      dataLocatorKey,
      isStoreDetailsDesktopRedesignEnabled,
      variation,
      isFavorite,
      isStoreDetailsRedesignMobileEnabled,
      showSetFavorite,
      store,
    } = this.props;
    if (storeName) {
      return !isStoreDetailsDesktopRedesignEnabled ? (
        <div className="store-details-header">
          {!titleClickCb && (
            <BodyCopy
              className="store-name store-name--details"
              fontSize="fs16"
              component="h3"
              fontWeight="extrabold"
              customStyle={store?.isGym ? customStyle : {}}
            >
              {storeName?.toLowerCase()}
            </BodyCopy>
          )}
          {titleClickCb && (
            <button
              className="store-name store-name--details-btn"
              onClick={titleClickCb}
              data-locator={getLocator(`store_${dataLocatorKey}addresslabel`)}
            >
              {storeName?.toLowerCase()}
            </button>
          )}
          {this.renderFavIcon(
            isStoreDetailsRedesignMobileEnabled,
            variation,
            isFavorite,
            showSetFavorite
          )}
        </div>
      ) : (
        <div className="store-details-header">
          {' '}
          {!titleClickCb && (
            <BodyCopy
              className="store-name store-name--details-new"
              fontSize="fs16"
              component="h1"
              fontWeight="extrabold"
              customStyle={customStyle}
            >
              {storeName?.toLowerCase()}
            </BodyCopy>
          )}
          {titleClickCb && (
            <button
              className="store-name store-name--details-new-btn"
              onClick={titleClickCb}
              data-locator={getLocator(`store_${dataLocatorKey}addresslabel`)}
            >
              {storeName?.toLowerCase()}
            </button>
          )}
          <div className="address-meta__right">
            {variation === detailsType && !isFavorite && showSetFavorite && this.getFavLink()}
            {variation === detailsType && isFavorite && this.getIsFavStoreIcon()}
          </div>
        </div>
      );
    }
    return null;
  }

  getListingHeader() {
    const {
      openStoreDetails,
      store,
      openStoreDirections,
      geoLocationDisabled,
      updateStore,
      isStsCtaEnabled,
      trackAnalyticsClick,
      isShopThisStoreEnabled,
    } = this.props;
    const { isGym, basicInfo, distance, hours } = store;
    const { storeName, address, phone } = basicInfo;
    const { addressLine1, city, state, zipCode } = address || {};
    if (!addressLine1 && !isErrorLogged) {
      logger.error({
        error: 'Missing store address in StoreAddressTile',
        extraData: {
          store: JSON.stringify(store),
          methodName: 'getListingHeader',
        },
      });
      isErrorLogged = true;
    }
    const currentDate = getDateObject();
    const storeHours = getStoreHours(hours, this.storeLabels, currentDate);
    return (
      <div className="listing-header">
        <div className="heading-left">
          <div className="title">
            <div className="title__one">
              <BodyCopy
                fontSize="fs14"
                component="span"
                color="text.primary"
                fontFamily="secondary"
                fontWeight="semibold"
              >
                {storeName}
              </BodyCopy>
            </div>
            <div className="title__two">
              {storeHours && (
                <BodyCopy
                  fontSize="fs12"
                  component="span"
                  color="text.primary"
                  fontFamily="secondary"
                >
                  {`(${storeHours})`}
                </BodyCopy>
              )}
              {!geoLocationDisabled && (
                <BodyCopy
                  fontSize="fs12"
                  component="span"
                  color="text.primary"
                  fontFamily="secondary"
                >
                  {`${
                    distance
                      ? `${(distance * 0.000621371).toFixed(2)} ${renderLabel(
                          this.storeLandingLabels.lbl_storelanding_milesAway,
                          'lbl_storelanding_milesAway'
                        )}`
                      : ''
                  }`}
                </BodyCopy>
              )}

              <ClickTracker
                as={Anchor}
                fontSizeVariation="medium"
                underline
                url={openStoreDirections(store)}
                anchorVariation="primary"
                target="_blank"
                className="store-directions-link"
                clickData={{ customEvents: ['event97'] }}
                aria-label={`${storeName} ${renderLabel(
                  this.storeLandingLabels.lbl_storelanding_getdirections_link,
                  'lbl_storelanding_getdirections_link'
                )}`}
              >
                {renderLabel(
                  this.storeLandingLabels.lbl_storelanding_getdirections_link,
                  'lbl_storelanding_getdirections_link'
                )}
              </ClickTracker>
            </div>
          </div>
          <div className="address-wrapper">
            <address className="address-details address-details--listing-header">
              <div className="address-inline">
                <BodyCopy fontSize="fs12" component="span" fontFamily="secondary">
                  {`${addressLine1} ${city}, ${state}, ${zipCode} | ${phone}`}
                </BodyCopy>
              </div>
              <div className="address-block">
                {[addressLine1, `${city}, ${state}, ${zipCode}`, phone].map((item, i) => (
                  <BodyCopy
                    key={`${item + i}`}
                    fontSize="fs12"
                    component="span"
                    fontFamily="secondary"
                  >
                    {item}
                    <br />
                  </BodyCopy>
                ))}
              </div>
            </address>
            {isGym && this.getBrandStoreIcon('brand-store--sm')}
          </div>
        </div>
        <div className="heading-right">
          {isShopThisStoreEnabled
            ? isStsCtaEnabled &&
              this.renderStsCta(basicInfo, updateStore, store, trackAnalyticsClick, true)
            : ''}
          <Anchor
            fontSizeVariation="medium"
            underline
            to={`/${getSiteId()}${routeToStoreDetails(store).url}`}
            handleLinkClick={(event) => openStoreDetails(event, store)}
            anchorVariation="primary"
            target="_blank"
            className="store-details-link"
            noLink
            aria-label={`${storeName} ${renderLabel(
              this.storeLandingLabels.lbl_storelanding_storedetails_link,
              'lbl_storelanding_storedetails_link'
            )}`}
          >
            {renderLabel(
              this.storeLandingLabels.lbl_storelanding_storedetails_link,
              'lbl_storelanding_storedetails_link'
            )}
          </Anchor>
          {isShopThisStoreEnabled
            ? !isStsCtaEnabled &&
              this.renderStsCta(basicInfo, updateStore, store, trackAnalyticsClick, false)
            : ''}
        </div>
      </div>
    );
  }

  getListingTileHeader() {
    const { storeIndex, store, openStoreDirections, titleClickCb, geoLocationDisabled } =
      this.props;
    const { basicInfo, distance, hours } = store;
    const { storeName, id } = basicInfo;
    const currentDate = getDateObject();
    const storeHours = getStoreHours(hours, this.storeLabels, currentDate);

    return (
      <div className="store-listing-header">
        <div className="title-one">
          <BodyCopy
            fontSize="fs14"
            component={titleClickCb ? Anchor : 'span'}
            color="text.primary"
            fontFamily="secondary"
            fontWeight="semibold"
            className="store-name store-name--listing"
            handleLinkClick={(e) => titleClickCb(e, id)}
            noLink
          >
            {!!storeIndex && `${storeIndex}. `}
            {storeName}
          </BodyCopy>
        </div>
        <div className="title-two">
          {storeHours && (
            <BodyCopy fontSize="fs12" component="span" color="text.primary" fontFamily="secondary">
              {`(${storeHours})`}
            </BodyCopy>
          )}
          {!geoLocationDisabled && (
            <BodyCopy fontSize="fs12" component="span" color="text.primary" fontFamily="secondary">
              {`${
                distance
                  ? `${(distance * 0.000621371).toFixed(2)} ${renderLabel(
                      this.storeLandingLabels.lbl_storelanding_milesAway,
                      'lbl_storelanding_milesAway'
                    )}`
                  : ''
              }`}
            </BodyCopy>
          )}
          <ClickTracker
            as={Anchor}
            fontSizeVariation="medium"
            underline
            url={openStoreDirections(store)}
            anchorVariation="primary"
            target="_blank"
            className="store-directions-link"
            aria-label={`${storeName} ${renderLabel(
              this.storeLandingLabels.lbl_storelanding_getdirections_link,
              'lbl_storelanding_getdirections_link'
            )}`}
            clickData={{ customEvents: ['event97'] }}
          >
            {renderLabel(
              this.storeLandingLabels.lbl_storelanding_getdirections_link,
              'lbl_storelanding_getdirections_link'
            )}
          </ClickTracker>
        </div>
      </div>
    );
  }

  getStoreType() {
    const {
      store: { features },
    } = this.props;
    const { storeType } = features;
    return (
      <BodyCopy
        fontSize="fs12"
        component="div"
        color="text.primary"
        fontFamily="secondary"
        className="store-type"
      >
        <Image
          className="store-type__marker"
          src={getIconPath('marker-icon-blue')}
          alt={storeType}
          title={storeType}
        />
        <BodyCopy className="store-type__text" component="span" fontFamily="secondary">
          {storeType}
        </BodyCopy>
      </BodyCopy>
    );
  }

  getBrandStoreIcon(cls = '') {
    const { dataLocatorKey } = this.props;
    return (
      <BodyCopy
        fontSize="fs12"
        component="div"
        color="text.primary"
        fontFamily="secondary"
        className={`brand-store ${cls}`}
        dataLocator={getLocator(`store_${dataLocatorKey}gymboreetstorelabel`)}
      >
        <Image
          src={getIconPath('gymboree-icon')}
          alt="Gymboree"
          title="Gymboree Store"
          className="brand-store__image"
        />
        <BodyCopy className="brand-store__text" component="span" fontFamily="secondary">
          {renderLabel(
            this.storeLandingLabels.lbl_storelanding_atThisPlace,
            'lbl_storelanding_atThisPlace'
          )}
        </BodyCopy>
      </BodyCopy>
    );
  }

  getFavLink() {
    const {
      setFavoriteStore,
      store,
      locatorSetFavStore,
      setDefaultSuggestedStoresAction,
      isBossMultiStoreEnabled,
      isStoreDetailsDesktopRedesignEnabled,
      isStoreDetailsRedesignMobileEnabled,
    } = this.props;
    const { basicInfo } = store;
    const { storeName } = basicInfo;
    const callback = () => {
      if (isBossMultiStoreEnabled) {
        setDefaultSuggestedStoresAction([store]);
      }
      setFavoriteStore(store);
    };
    return isStoreDetailsDesktopRedesignEnabled || isStoreDetailsRedesignMobileEnabled ? (
      <BodyCopy onClick={callback}>
        <Image
          src={getIconPath('transparentFavIcon')}
          alt="transparentFavIcon"
          className="favorite-store-icon"
        />
      </BodyCopy>
    ) : (
      <Button
        buttonVariation="fixed-width"
        type="button"
        fill={isSNJ() ? 'SNJ_SECONDARY' : ''}
        data-locator={locatorSetFavStore}
        onClick={callback}
        title={renderLabel(
          this.storeLandingLabels.lbl_storelanding_storedetails_link,
          'lbl_storelanding_storedetails_link'
        )}
        aria-label={`${storeName} ${renderLabel(
          this.storeLandingLabels.lbl_storelanding_setfavStore,
          'lbl_storelanding_setfavStore'
        )}`}
      >
        {renderLabel(
          this.storeLandingLabels.lbl_storelanding_setfavStore,
          'lbl_storelanding_setfavStore'
        )}
      </Button>
    );
  }

  renderAddressItem = (addressLine1, cityTxt, phone, distance) => {
    return [addressLine1, cityTxt, phone, distance].map((item, i) => {
      return item !== phone ? (
        <span key={`${item + i}`}>{item}</span>
      ) : (
        <a className="phone-number" href={`tel: ${item}`}>
          {item}
        </a>
      );
    });
  };

  calculateDistance = (variation, store) => {
    return variation === detailsType && store.distance
      ? `${(store.distance * 0.000621371).toFixed(2)} ${renderLabel(
          this.storeLandingLabels.lbl_storelanding_milesAway,
          'lbl_storelanding_milesAway'
        )}`
      : null;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getStoreAddress() {
    const {
      store,
      variation,
      isFavorite,
      isStoreDetailsDesktopRedesignEnabled,
      isStoreDetailsRedesignMobileEnabled,
    } = this.props;
    const { address, phone } = store.basicInfo;
    const { addressLine1, city, state, zipCode } = address || {};
    if (!addressLine1 && !isErrorLogged) {
      logger.error({
        error: 'Missing store address in StoreAddressTile',
        extraData: {
          store: JSON.stringify(store),
          methodName: 'getStoreAddress',
        },
      });
      isErrorLogged = true;
    }
    const distance = this.calculateDistance(variation, store);

    const cityTxt = storeAddressText(city, state, zipCode);
    return isStoreDetailsDesktopRedesignEnabled || isStoreDetailsRedesignMobileEnabled ? (
      <div className="address-wrapper">
        <div className="address-meta">{store.isGym ? this.getBrandStoreIcon() : null}</div>
        <div className="address-details">
          {this.renderAddressItem(addressLine1, cityTxt, phone, distance)}
        </div>
      </div>
    ) : (
      <div className="address-wrapper">
        <BodyCopy
          fontSize={variation === detailsType ? 'fs14' : 'fs12'}
          component="address"
          color="text.primary"
          fontFamily="secondary"
          className="address-details"
        >
          {[addressLine1, cityTxt, phone, distance].map(
            (item, i) =>
              item && (
                <BodyCopy
                  key={`${item + i}`}
                  fontSize={variation === detailsType ? 'fs14' : 'fs12'}
                  component="span"
                  fontFamily="secondary"
                >
                  {item}
                  <br />
                </BodyCopy>
              )
          )}
        </BodyCopy>

        <div className="address-meta">
          <div className="address-meta__left">
            {variation === detailsType && store.features && this.getStoreType()}
            {store.isGym ? this.getBrandStoreIcon() : null}
          </div>
          {!isStoreDetailsDesktopRedesignEnabled && !isStoreDetailsRedesignMobileEnabled && (
            <div className="address-meta__right">
              {variation === detailsType && isFavorite && this.getIsFavStoreIcon()}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderStsCta(basicInfo, updateStore, store, trackAnalyticsClick, right, flags) {
    const fromStoreDetailPage = flags?.fromStoreDetailPage;
    if (right) {
      return (
        <ShopThisStoreCta
          basicInfo={basicInfo}
          updateStore={updateStore}
          store={store}
          trackAnalyticsClick={trackAnalyticsClick}
          classForMargin="cta-right"
          fromStoreDetailPage={fromStoreDetailPage}
        />
      );
    }

    let leftclass = 'cta-left';
    if (flags) {
      leftclass =
        (flags?.isStoreDetailsDesktopRedesignEnabled ||
          flags?.isStoreDetailsRedesignMobileEnabled) &&
        flags?.fromCurrentSelectedStore
          ? 'cta-left'
          : '';
    }

    return (
      <ShopThisStoreCta
        basicInfo={basicInfo}
        updateStore={updateStore}
        store={store}
        trackAnalyticsClick={trackAnalyticsClick}
        classForMargin={leftclass}
        fromStoreDetailPage={fromStoreDetailPage}
      />
    );
  }

  render() {
    const {
      className,
      children,
      variation,
      store,
      selectedStoreId,
      isStoreDetailsDesktopRedesignEnabled,
      isStoreDetailsRedesignMobileEnabled,
      type,
      ...rest
    } = this.props;
    const fromCurrentSelectedStore = type !== 'storelocations';
    const styleProp =
      (isStoreDetailsDesktopRedesignEnabled || isStoreDetailsRedesignMobileEnabled) &&
      !fromCurrentSelectedStore;
    const isGym = store?.isGym;
    return (
      <div
        className={`address-tile ${className} ${
          selectedStoreId ? 'address-tile__selectedStore' : ''
        }`}
      >
        {variation === listingHeader && this.getListingHeader()}
        {variation !== listingHeader && !isStoreDetailsDesktopRedesignEnabled && (
          <Fragment>
            <TileHeader
              className="tile-header"
              variation={variation}
              isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
              {...rest}
            >
              {variation === detailsType && this.getDetailsTileHeader()}
              {variation === listingType && this.getListingTileHeader()}
            </TileHeader>
            <TileBody
              className="tile-body"
              variation={variation}
              isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
              isGym={isGym}
              {...rest}
            >
              {this.getStoreAddress()}
              {children}
            </TileBody>
            <TileFooter
              className="tile-footer"
              variation={variation}
              store={store}
              isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
              fromCurrentSelectedStore={fromCurrentSelectedStore}
              styleProp={styleProp}
              {...rest}
            >
              {variation === detailsType && this.getDetailsTileFooter(fromCurrentSelectedStore)}
              {variation === listingType && this.getListingTileFooter(store)}
            </TileFooter>
          </Fragment>
        )}
        {variation !== listingHeader && isStoreDetailsDesktopRedesignEnabled && (
          <div className="current-store-tile">
            <TileBody
              className="tile-body"
              variation={variation}
              isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
              isGym={isGym}
              {...rest}
            >
              <TileHeader className="tile-header" variation={variation} {...rest}>
                {variation === detailsType && this.getDetailsTileHeader()}
              </TileHeader>
              {this.getStoreAddress()}
              {children}
            </TileBody>
            <TileFooter
              className="tile-footer"
              variation={variation}
              store={store}
              isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
              fromCurrentSelectedStore={fromCurrentSelectedStore}
              styleProp={styleProp}
              {...rest}
            >
              {variation === detailsType && this.getDetailsTileFooter(fromCurrentSelectedStore)}
            </TileFooter>
          </div>
        )}
      </div>
    );
  }
}

StoreAddressTile.propTypes = propTypes;

StoreAddressTile.defaultProps = defaultProps;

export default withStyles(StoreAddressTile, style);

export { StoreAddressTile as StoreAddressTileVanilla };
